import { ApolloClient, NormalizedCacheObject, gql } from '@apollo/client';
import { IncomingHttpHeaders } from 'http';

import {
  GetCartByIdQuery,
  GetCartByIdQueryVariables,
} from '../../ts/@types/generated/graphql/cart-order-service/graphql';

export const GET_CART_BY_ID = gql`
  query getCartById($uuid: UUID!) {
    cart(uuid: $uuid) {
      uuid
      userId
      orderOn
      customizeBy
      deliveryDates
      status
      createdAt
      legacyOrderId
      tenantEligibilityConfigLogicalId
      subscription {
        uuid
      }
      cartDeliveries {
        id
        createdAt
        updatedAt
        locationId
        status
        deliveryType
        deliveryDate
        estimatedTransitTime
        estimatedDeliveryDate
        lineItems {
          id
          createdAt
          updatedAt
          variantId
          variant
          price
          quantity
        }
      }
      funnelData
      cartLedger {
        id
        createdAt
        updatedAt
        subtotal
        discountTotal
        deliveryTotal
        tax
        grandTotal
        creditTotal
        precreditTotal
      }
      discount {
        amount
        code
        type
      }
      cartError {
        validation {
          quantity {
            message
            deliveryId
          }
          status {
            message
          }
          catalog {
            message
          }
          customizeBy {
            message
          }
        }
      }
    }
  }
`;

export async function getCartById(
  client: ApolloClient<NormalizedCacheObject>,
  headers: IncomingHttpHeaders,
  uuid: string,
  clientName = 'cart-order-service',
): Promise<GetCartByIdQuery['cart']> {
  const response = await client.query<
    GetCartByIdQuery,
    GetCartByIdQueryVariables
  >({
    query: GET_CART_BY_ID,
    variables: { uuid },
    context: { headers, clientName },
  });
  return response.data.cart;
}
